import { Button, Form, Input, message, Modal, Row, Table } from 'antd';
import { useEffect, useState } from 'react';
import moment from 'moment';
import {
    BusinessMsg,
    createResourceGroup,
    fetchResourceGroups,
    ResourceStatusMsg,
    updateResourceGroup,
} from '@services/api/resource';
import { BusinessSelector, ResourceStatusSelector } from '@shared/components/biz/selector';

const { Item } = Form;
export const TechResourceGroup = () => {
    const [form] = Form.useForm();
    const [newForm] = Form.useForm();
    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [data, setData] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [visible, setVisible] = useState<boolean>(false);
    const [detail, setDetail] = useState<any>({});
    const refresh = (newPage?: number, newPageSize?: number) => {
        const params = { ...form.getFieldsValue() };
        return fetchResourceGroups({ ...params, page: newPage, pageSize: newPageSize }).then(rep => {
            setData(rep.data.items);
            setPage(newPage ?? page);
            setPageSize(newPageSize ?? pageSize);
            setTotal(rep.data.total);
        });
    };
    useEffect(() => {
        refresh(page, pageSize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <Form layout="inline" form={form}>
                <Item name="id" label="ID">
                    <Input placeholder="请输入" />
                </Item>
                <Item name="name" label="名称">
                    <Input placeholder="请输入" />
                </Item>
                <Item name="businessId" label="产品线">
                    <BusinessSelector useId />
                </Item>
                <Button
                    type="primary"
                    onClick={() => {
                        refresh(1, pageSize);
                    }}
                >
                    搜索
                </Button>
                <Button
                    onClick={() => {
                        form.resetFields();
                        refresh(1, pageSize);
                    }}
                    type="default"
                    style={{ marginLeft: 10 }}
                >
                    重置
                </Button>
            </Form>
            <Row justify="space-between" style={{ marginBottom: 10, marginTop: 10 }}>
                <Button
                    type="primary"
                    onClick={() => {
                        setDetail({});
                        setVisible(true);
                        newForm.resetFields();
                    }}
                >
                    添加
                </Button>
            </Row>
            <Table
                dataSource={data}
                columns={[
                    {
                        title: 'ID',
                        dataIndex: 'id',
                        width: 80,
                    },
                    {
                        title: '名称',
                        dataIndex: 'name',
                    },
                    {
                        title: '说明',
                        dataIndex: 'description',
                    },

                    {
                        title: '产品线',
                        dataIndex: 'businessId',
                        render: value => BusinessMsg[value],
                        width: 100,
                    },
                    {
                        title: '状态',
                        dataIndex: 'status',
                        render: value => ResourceStatusMsg[value],
                        width: 80,
                    },
                    {
                        width: 180,
                        title: '修改时间',
                        dataIndex: 'updateTime',
                        render: value => moment(value).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                        width: 180,
                        title: '添加时间',
                        dataIndex: 'createTime',
                        render: value => moment(value).format('YYYY-MM-DD HH:mm:ss'),
                    },
                    {
                        title: '操作',
                        render: (value, row) => (
                            <Button
                                type="primary"
                                onClick={() => {
                                    newForm.setFieldsValue({
                                        name: row.name,
                                        description: row.description,
                                        businessId: row.businessId,
                                        status: row.status,
                                    });
                                    setDetail({ ...row });
                                    setVisible(true);
                                }}
                            >
                                编辑
                            </Button>
                        ),
                    },
                ]}
                pagination={{
                    current: page,
                    pageSize,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    onChange: (page, pageSize) => {
                        refresh(page, pageSize);
                    },
                    total,
                    showTotal: (total: number) => `共${total}条`,
                }}
            />
            <Modal
                destroyOnClose
                title={detail?.id ? '修改资源组' : '添加资源组'}
                visible={visible}
                onCancel={() => {
                    setDetail(undefined);
                    setVisible(false);
                }}
                onOk={() => {
                    const data = newForm.getFieldsValue();
                    if (!detail?.id && Object.keys(data).some(key => !data[key] && key !== 'description')) {
                        return message.error('请填写完整表单');
                    }
                    const action = detail?.id
                        ? updateResourceGroup(detail.id, {
                              ...data,
                          })
                        : createResourceGroup({
                              ...detail,
                              ...data,
                          });
                    action.then(rep => {
                        if (!rep.code) {
                            message.success('操作成功');
                            setVisible(false);
                            setDetail(undefined);
                            refresh(1, pageSize);
                        } else {
                            message.error(rep?.error?.msg || rep?.msg || '服务器错误');
                        }
                    });
                }}
            >
                <Form form={newForm} labelCol={{ span: 4 }}>
                    <Item name="name" label="名称" required>
                        <Input />
                    </Item>
                    <Item name="description" label="说明">
                        <Input />
                    </Item>
                    <Item name="businessId" label="产品线" required>
                        <BusinessSelector useId />
                    </Item>
                    <Item name="status" label="状态" required>
                        <ResourceStatusSelector />
                    </Item>
                </Form>
            </Modal>
        </>
    );
};
